import React from 'react';

type KavlingStatus = 'AVAILABLE' | 'HOLD' | 'BOOKED' | 'SOLD' | 'BLOCKED';
type LeadStatus = 'New' | 'Contacted' | 'Survey' | 'Booking' | 'Closing';
type CommissionStatus = 'Potential' | 'Approved' | 'Paid';

type BadgeStatus = KavlingStatus | LeadStatus | CommissionStatus;

const statusConfig: Record<BadgeStatus, { label: string; className: string }> = {
  AVAILABLE: { label: 'Tersedia', className: 'status-available' },
  HOLD: { label: 'Hold', className: 'status-hold' },
  BOOKED: { label: 'Booking', className: 'status-booked' },
  SOLD: { label: 'Terjual', className: 'status-sold' },
  BLOCKED: { label: 'Blokir', className: 'status-blocked' },
  New: { label: 'Baru', className: 'bg-purple/10 text-purple' },
  Contacted: { label: 'Dihubungi', className: 'bg-blue/10 text-blue' },
  Survey: { label: 'Survey', className: 'bg-orange/10 text-orange' },
  Booking: { label: 'Booking', className: 'status-booked' },
  Closing: { label: 'Closing', className: 'status-available' },
  Potential: { label: 'Potensi', className: 'bg-orange/10 text-orange' },
  Approved: { label: 'Disetujui', className: 'bg-secondary/10 text-secondary' },
  Paid: { label: 'Dibayar', className: 'status-available' },
};

interface StatusBadgeProps {
  status: BadgeStatus;
  size?: 'sm' | 'md';
}

export default function StatusBadge({ status, size = 'md' }: StatusBadgeProps) {
  const config = statusConfig[status] ?? { label: status, className: 'bg-muted text-muted-foreground' };
  return (
    <span
      className={`inline-flex items-center font-semibold rounded-full ${config.className} ${
        size === 'sm' ? 'text-xs px-2 py-0.5' : 'text-xs px-2.5 py-1'
      }`}
    >
      {config.label}
    </span>
  );
}